import { ReactNode, useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { APIRequestGet, APIRequestPost } from '../../utils/APIRequests';
import {
    AstraAdminSubscriptionData,
    AstraAdminSubscriptionProlongationRequestData,
    AstraAdminSubscriptionSchema
} from './api/AstraAdminSubscription';

/** Подписка модема на его админской странице: срок и продление. */
function AdminModemSubscription({ imei }: { imei: string }): ReactNode {
    const [subscription, setSubscription] = useState<AstraAdminSubscriptionData>();
    const [prolongationDays, setProlongationDays] = useState<number>(30);
    const [isProlongation, setIsProlongation] = useState(false);

    useEffect(() => {
        APIRequestGet(`/astraAdminSubscription/getByImei?imei=${imei}`, {
            schema: AstraAdminSubscriptionSchema,
            logSuccess: true
        }).then((result) => {
            setSubscription(result.data);
        });
    }, [imei]);

    function prolongation() {
        // Пустое поле даёт Number("") === 0: продление на 0 дней перепишет
        // TimeDeactivation, поэтому такой запрос отправлять нельзя.
        if (!Number.isFinite(prolongationDays) || prolongationDays <= 0) {
            return;
        }

        const data: AstraAdminSubscriptionProlongationRequestData = {
            days: prolongationDays,
            imei: imei
        };

        setIsProlongation(true);
        APIRequestPost('/astraAdminSubscription/prolongation', {
            data: data,
            logSuccess: true
        }).then(() => {
            window.location.reload();
        }).finally(() => setIsProlongation(false));
    }

    return (
        <>
            <p>Subscription:</p>
            {subscription != null &&
                <table
                    className='table table-striped'
                    aria-labelledby="tableLabel"
                    style={{ tableLayout: "fixed" }}
                >
                    <thead>
                        <tr>
                            <th style={{ width: "30%" }}>Time create</th>
                            <th style={{ width: "30%" }}>Time deactivation</th>
                            <th style={{ width: "30%" }}>Prolongation days</th>
                            <th style={{ width: "30%" }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{subscription.timeCreate}</td>
                            {subscription.isRotten ? (
                                <td style={{ color: "red" }}>{subscription.timeDeactivation}</td>
                            ) : (
                                <td>{subscription.timeDeactivation}</td>
                            )}
                            <td style={{ fontSize: "15px" }}>
                                <Form.Control
                                    type="number"
                                    defaultValue={prolongationDays}
                                    onChange={(event) => { setProlongationDays(Number(event.target.value)) }}
                                />
                            </td>
                            <td>
                                <button
                                    style={{ width: "100%" }}
                                    className="btn btn-danger"
                                    disabled={isProlongation || !Number.isFinite(prolongationDays) || prolongationDays <= 0}
                                    onClick={() => { prolongation(); }}
                                >
                                    Prolongation
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            }
        </>
    );
}

export default AdminModemSubscription;
